import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef,
    Renderer2/*, OnChanges, SimpleChanges*//*, AfterViewChecked*/
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';

import {SlickGridComponent} from 'app/slick-grid/slick-grid.component';
import {BufferGraphService} from 'app/buffer-graph/services/buffer-graph.service';
import {ISlickGridColumn} from 'app/slick-grid/interfaces/slick-grid-column';
import {EventArgs} from 'app/slick-grid/models/event-args';
import {TabComponentBase} from 'app/buffer-graph/models/tab-component-base';
import {ItemAction} from 'app/buffer-graph/models/item-actions/item-action';
import {FreshItemActionHeader} from 'app/buffer-graph/models/item-actions/fresh-item-action-header';
import {FreshItemActionLine} from 'app/buffer-graph/models/item-actions/fresh-item-action-line';
import {ResizeDirection} from 'app/resize-glyph/resize-glyph.component';
import {Size} from 'app/shared/models/size';
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";

type Action = ItemAction | FreshItemActionHeader;

@Component({
    selector: 'item-actions',
    templateUrl: './item-actions.component.html',
    styleUrls: ['../../../slick-grid/stocks-grid-style.css', '../../styles/tabs-styles.css', './item-actions.component.css']
})
export class ItemActionsComponent extends TabComponentBase<Action, { columns: { header: string, field: string }[], mainRows: any[] }> /*implements OnChanges*/
    /*, AfterViewChecked*/{
    constructor(graphService: BufferGraphService, exchangeService: BufferGraphDataExchangeService, translateService: TranslateService, renderer: Renderer2, elementRef: ElementRef){
        super(graphService, exchangeService, translateService, renderer, elementRef);

        this.showCurrentActions = new EventEmitter<void>();
        this.showAllActions = new EventEmitter<void>();

        this.dataView = new Slick.Data.DataView<Action>();
        this.dataView.onRowsChanged.subscribe(() => this.setMainGridSellStyles());

        this.options = {syncColumnCellResize: true, multiColumnSort: true, editable: false};

        this.lineDataView = new Slick.Data.DataView<FreshItemActionLine>();
        this.lineOptions = {syncColumnCellResize: true, multiColumnSort: true, editable: false};
        this.generateColumns = true;
        this.resizeValue = 0;
        this.translateService.get('Actions').subscribe(t => this.mainRowsSheetName = t);
    }

    @ViewChild('grid')
    protected gridRef: SlickGridComponent;

    @ViewChild('gridLine')
    protected gridLineRef: SlickGridComponent;

    @ViewChild('headers')
    private headersRef: ElementRef;

    @ViewChild('lines')
    private linesRef: ElementRef;

    @ViewChild('resizeWrp')
    private resizeWrpRef: ElementRef;

    @Input()
    protected isActive: boolean;

    @Input()
    private allShown: boolean;

    private data: Action[];

    @Input()
    private set actions(actions: Action[]){

        this.data = actions;

        this.dataView.setItems(actions);
        this.selectedFreshHeader = null;
        this.lineDataView.setItems([]);
    }

    // @Input()
    // protected sku: string;
    //
    // @Input()
    // protected warehouseCode: string;

    private isFresh: boolean;

    @Input()
    private set fresh(value: boolean){
        this.heightCoeff = value ? {gr: 50, fgr: 50} : {gr: 100, fgr: 0};
        if (this.isFresh === value && this.isFresh != null)
            return;

        this.isFresh = value;
        this.GUID = this.helper.generateGUID();

        //this.setColumns();
    }

    @Input()
    protected canSend: boolean;

    @Input()
    protected columnLineSettings: ColumnSettingsBase[];

    @Output()
    private readonly showCurrentActions: EventEmitter<void>;

    @Output()
    private readonly showAllActions: EventEmitter<void>;

    private get verticalDirection(): ResizeDirection{
        return ResizeDirection.Vertical;
    }

    private readonly lineDataView: Slick.Data.DataView<FreshItemActionLine>;

    protected lineColumns: ISlickGridColumn<FreshItemActionLine>[];

    private readonly lineOptions: Slick.GridOptions<FreshItemActionLine>;

    private selectedFreshHeader: FreshItemActionHeader;

    private resizeTimer: any;

    private resizeValue: number;

    private freshTemplateRows: string;

    private GUID: string;

    public heightCoeff: { gr: number, fgr: number };

    //# use default function for export data
    protected getExportData = this.getExportDataByDefault;

    //# if fresh, we have resizer, if we change height of grids, we update grids
    protected onActoinTabsResized = (): boolean =>{
        if (!this.onTabsResized(this.sharedGUID))
            return false;

        return true;
    }

    //# update data for line table
    private onMainGridActiveCellChanged = (args: EventArgs<Slick.OnActiveCellChangedEventArgs<any>>): void =>{
        let action: FreshItemActionHeader;
        if (!this.isFresh || (action = this.dataView.getItemByIdx(args.data.row) as FreshItemActionHeader) === this.selectedFreshHeader)
            return;

        this.lineDataView.setItems(action.lines);
        this.gridLineRef.setColumns(this.lineColumns);
        this.gridLineRef.invalidate();
        this.gridLineRef.render();
        this.selectedFreshHeader = action;
    }

    //# show all data (not use now)
    private onShowCurrentClick = (): void =>{
        if (!this.allShown)
            return;

        this.showCurrentActions.emit();
    }

    //# show all data (not use now)
    private onShowAllClick = (): void =>{
        if (this.allShown)
            return;

        this.showAllActions.emit();
    }


    //# download excel
    private onDownloadClick = (): void =>{
        // if (this.isFresh)
        //     return;
        const fileName = `Actions_SKU_${this.tab.itemInfo.sku}_Wrh_${this.tab.itemInfo.warehouseCode}.xlsx`;
        this.download(data => this.graphService.downloadItemActions(data.columns, data.mainRows, moment.locale(), this.mainRowsSheetName)
            .map(file =>{
                return {fileContent: file, fileName};
            }));
    }

    //# send excel to email
    private onSendClick = (): void =>{
        // if (this.isFresh)
        //     return;
        this.sendToEmail(data => this.graphService.sendItemActions(this.tab.itemInfo.sku, this.tab.itemInfo.warehouseCode, data.columns, data.mainRows, moment.locale(), this.mainRowsSheetName));
    }

    //# recalculate grid dimensions when we pull resizer
    private onGridsResizedBy = (size: Size): void =>{
        if (this.resizeTimer)
            clearTimeout(this.resizeTimer);

        this.resizeValue += size.height;

        this.resizeTimer = setTimeout(() =>{
            clearTimeout(this.resizeTimer)
            this.resizeTimer = null;

            let headersHeight = this.headersRef.nativeElement.offsetHeight,
                linesHeight = this.linesRef.nativeElement.offsetHeight;
            const resizeWrpRefHeight = this.resizeWrpRef.nativeElement.offsetHeight,
                diff = resizeWrpRefHeight - (headersHeight + linesHeight + 5);
                console.log(diff, 'diff')

            if (diff > 1 || diff < -1){
                headersHeight += diff * (headersHeight - 5) / resizeWrpRefHeight;
                linesHeight += diff * (linesHeight - 5) / resizeWrpRefHeight;
            }

            let gr = (headersHeight + this.resizeValue - 5) * 100 / resizeWrpRefHeight,
                fgr = (linesHeight - this.resizeValue) * 100 / resizeWrpRefHeight;

            if (gr * resizeWrpRefHeight / 100 < 100){
                this.heightCoeff.gr = (100 / resizeWrpRefHeight) * 100;
                this.heightCoeff.fgr = ((resizeWrpRefHeight - 100 - 5) / resizeWrpRefHeight) * 100;
            } else if (fgr * resizeWrpRefHeight / 100 < 100){
                this.heightCoeff.fgr = this.heightCoeff.gr = (100 / resizeWrpRefHeight) * 100;
                this.heightCoeff.gr = ((resizeWrpRefHeight - 100 - 5) / resizeWrpRefHeight) * 100;
            } else{
                this.heightCoeff.gr = gr;
                this.heightCoeff.fgr = fgr;
            }

            /*let heightCoeff = (headersHeight - this.resizeValue) / (headersHeight + linesHeight);
            if (heightCoeff < 0)
                heightCoeff = 0;
            else if (heightCoeff > 1)
                heightCoeff = 1;

            localStorage['IaHeightCoeff'] = heightCoeff;
            this.freshTemplateRows = `${heightCoeff}fr min-content ${1 - heightCoeff}fr min-content`;*/

            this.onActoinTabsResized();

            this.resizeValue = 0;
        }, 100);
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/item-actions.component/item-actions.component.ts